export default {"src":"/_next/static/image/public/images/icons2/6.e0d53376dd29912e151a1ce440315000.svg","height":24,"width":24};